import React from "react";
import { DropdownToggle } from "reactstrap";

const NameAvatar = (props) => (
  <DropdownToggle nav caret title={props.name} className="avatar-menu-name">
    <span className="text-uppercase">{props.name ? props.name[0] : ""}</span>
  </DropdownToggle>
);

export default NameAvatar;
